
import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import axiosInstance from "../../../api/api";

const EmpleadoForm = ({ initialData, empleado, empleadoForm, tipoEmpleado, onSubmit, onCancel }) => {
    const [formData, setFormData] = useState({
        cargo: '',
        numeroTrabajadores: '',
        salario: '',
        comision:'',
        prestacionesSociales: '',
        prestacionesSocialesVendedores:'',
        beneficiosLey: '',
        valorNomina: '',
        valorNominaMes: '',
        tipoempleado:tipoEmpleado,
        empleado:empleado
    });

    useEffect(() => {
        console.log("data inicial")
        console.log(formData)
        if (initialData) {
            setFormData({
                id:initialData.id || '',
                cargo: initialData.cargo || '',
                numeroTrabajadores: initialData.numeroTrabajadores || '',
                comision: initialData.comision || '',
                salario: initialData.salario || '',
                tipoempleado: initialData.tipoempleado || '',
                prestacionesSociales: initialData.prestacionesSociales || '',
                prestacionesSocialesVendedores: initialData.prestacionesSocialesVendedores || '',
                beneficiosLey: initialData.beneficiosLey || '',
                valorNomina: initialData.valorNomina || '',
                empleado: initialData.empleado || ''
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        console.log(e.target.value)
        const { name, value, type } = e.target;

        const newValue = type === "number" ? parseFloat(value) || 0 : value;

        const newData = {
            ...formData,
            [name]: newValue,
        };
        console.log(newData)
        newData.tipoEmpleado = tipoEmpleado;
        console.log("datos a calcular")
        console.log(newData)
        setFormData(newData);
        calculoEmpleado(newData);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const parsedData = {
            ...formData,
            numeroTrabajadores: parseFloat(formData.numeroTrabajadores),
            salario: parseFloat(formData.salario),
            comision: parseFloat(formData.comision),
            prestacionesSociales: parseFloat(formData.prestacionesSociales),
            prestacionesSocialesVendedores: parseFloat(formData.prestacionesSocialesVendedores),
            beneficiosLey: parseFloat(formData.beneficiosLey),
            valorNomina: parseFloat(formData.valorNomina)
        };
        onSubmit(parsedData);
    };
    const calculoEmpleado = (detailEmpleado) => {

        axiosInstance.post('/empleado/calculateDetail',detailEmpleado)
            .then((response) => {
            setFormData(response.data.data);
                console.log("detalle despues del calculo")
                console.log(response.data.data)
        }).catch((e) => {
            alert("Error consultando la tabla " + e)
        });
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                    {empleadoForm.map((empleado) => (
                        <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>{empleado.description}</Form.Label>
                        <Form.Control
                            type={empleado.type}
                            name={empleado.value}
                            value={formData[empleado.value] || ""}
                            onChange={handleChange}
                            readOnly={!empleado.editable}
                            min="0"
                            step="any"
                        />
                    </Form.Group>
                        </Col>
                    ))}
            </Row>

            <div className="d-flex justify-content-end">
                <Button variant="secondary" onClick={onCancel} className="me-2">
                    Cancelar
                </Button>
                <Button variant="primary" type="submit">
                    Guardar
                </Button>
            </div>
        </Form>
    );
};

export default EmpleadoForm;
